import React from 'react';

import Link from 'next/link';

import { withEventScope } from '@repo/event-processor';
import { themeStyle } from '@repo/ui/theming';
import { utilityClasses } from '@repo/ui-icons';
import IconChevronRight from '@repo/ui-icons/IconChevronRight';
import { H5 } from '@repo/ui-kit/components/core/Typography';

import MenuItem from 'components/HeadMenu/HeaderLayout/MenuItem';
import {
  LinkColumnElementsWrapper,
  LinkWrapper,
  LabelWrapper,
} from 'components/HeadMenu/HeaderLayout/styles';
import { LinksColumnProps } from 'components/HeadMenu/HeaderLayout/types';
import { FlexColumn } from 'styles/layouts';

const LinksColumn: React.FC<LinksColumnProps> = ({ item, small, onClick }) => {
  return (
    <FlexColumn>
      <LabelWrapper>
        {item.path ? (
          <Link
            href={item.path}
            // We don't want crawlers to follow links with query params
            rel={item.path.includes('?') ? 'nofollow' : ''}
            style={{ width: '100%' }}
            target={item.isAbsolutePath ? '_blank' : '_self'}
            onClick={onClick}
          >
            <LinkWrapper
              className={utilityClasses.iconEventWrapper}
              small={small}
            >
              <H5 as="span">{item.label}</H5>
              <IconChevronRight
                activeColor={themeStyle.varInkMain}
                color={themeStyle.varInkMedium}
                size={16}
              />
            </LinkWrapper>
          </Link>
        ) : (
          <H5 as="span">{item.label}</H5>
        )}
      </LabelWrapper>
      <LinkColumnElementsWrapper
        as="ul"
        columnsCount={item.groups.length}
        small={small}
      >
        {item.groups.map((group, i) => {
          return (
            <FlexColumn key={i}>
              {group.items.map((item) => {
                return (
                  <MenuItem
                    key={item.label}
                    description={item.description}
                    id={item.aiToolsTrackId}
                    image={item.image}
                    isAbsolutePath={item.isAbsolutePath}
                    label={item.label}
                    path={item.path}
                    small={small}
                    onClick={onClick}
                  />
                );
              })}
            </FlexColumn>
          );
        })}
      </LinkColumnElementsWrapper>
    </FlexColumn>
  );
};

export default withEventScope(LinksColumn, { module: 'headerMenuLinks' });
